﻿import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

type Toast = { message: string; kind?: 'ok' | 'error' };
const ToastContext = createContext<{ toast: (message: string, kind?: Toast['kind']) => void } | null>(null);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toastState, setToastState] = useState<Toast | null>(null);
  const value = useMemo(() => ({ toast: (message: string, kind: Toast['kind'] = 'ok') => {
    setToastState({ message, kind });
    window.setTimeout(() => setToastState(null), 2800);
  }}), []);
  return <ToastContext.Provider value={value}>{children}<div className={`toast ${toastState?.kind === 'error' ? 'error' : ''} ${toastState ? 'show' : ''}`}>{toastState?.message}</div></ToastContext.Provider>;
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used inside ToastProvider');
  return ctx.toast;
}
